import React, { useCallback, useEffect, useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import { useSuperadminAuth } from '../../context/SuperadminAuthContext';
import SuperAdminAIViewer from '../../components/superadmin/SuperAdminAIViewer';
import { ErrorState } from '../../components/superadmin/SuperAdminUI';

const DEFAULT_PAGINATION = { page: 1, pageSize: 10, total: 0, totalPages: 0 };

const ShopAIImages = () => {
  const { shop, shopId } = useOutletContext();
  const { getShopAiImages } = useSuperadminAuth();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [items, setItems] = useState([]);
  const [pagination, setPagination] = useState(DEFAULT_PAGINATION);

  const loadImages = useCallback(async (page = 1) => {
    try {
      setLoading(true);
      setError('');
      const response = await getShopAiImages(shopId, {
        page,
        pageSize: 10,
        sort: 'created_at',
        order: 'desc',
      });

      if (!response?.ok) {
        throw new Error('Failed to load AI images');
      }

      setItems(response.data || []);
      setPagination(response.pagination || DEFAULT_PAGINATION);
    } catch (err) {
      setError(err?.response?.data?.message || err.message || 'Failed to load AI images');
    } finally {
      setLoading(false);
    }
  }, [getShopAiImages, shopId]);

  useEffect(() => {
    loadImages(1);
  }, [loadImages]);

  return (
    <div className="space-y-6">
      {error ? <ErrorState error={error} onRetry={() => loadImages(pagination.page)} /> : null}
      <SuperAdminAIViewer
        items={items}
        shopName={shop?.name}
        loading={loading}
        pagination={pagination}
        onPageChange={loadImages}
      />
    </div>
  );
};

export default ShopAIImages;
